/**
 * Created by liux on 2017/12/27.
 * ios 和 android 协议不一致，调用方式相同，data暂时未定义结构
 * @param(data,cb) cd = {errcode:0, errstr:'登录成功'}
 * @return Boolean
 */
import xyJsBridge from './xyJsBridge'
import  Info from '../helper/getBrowserInfo'
var isIos = Info().ios
function openLoginPage(data,cb) {
  if(typeof data === 'function'){
    cb = data;
    data = {}
  }
  var scheme= 'jsbridge://www.xiaoying.com/app/account/login'
  if(isIos && window.xyJSBridgeInfo.jsbridgeversion >= "1.0.0"){
    scheme = 'jsbridge://www.xiaoying.com/app/operation/login'
  }
  return xyJsBridge(scheme,data,cb)
}

export default openLoginPage
